import React, { useEffect, createElement } from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { BenefitsSection } from './components/BenefitsSection';
import { RoadmapSection } from './components/RoadmapSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1498295128399383');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-body text-navy selection:bg-orange selection:text-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      {/* Add padding-top to account for the fixed sticky bar */}
      <main className="pt-12 md:pt-14" data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <RoadmapSection data-id="element-6" />
        <CtaSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}